export type UnsavedChangesReason = "saveFailed" | "fieldsNeedCorrecting";

export class UnsavedChangesError extends Error {
  constructor(
    readonly reason: UnsavedChangesReason = "saveFailed",
    readonly alreadyReported = false,
    cause?: unknown,
  ) {
    super("Pending changes could not be saved", { cause });
    this.name = "UnsavedChangesError";
  }
}
